import styled from "styled-components";

export const Screen = styled.div`
  background-color: #1e90ff;
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-size: cover;
  background-position: center;
  width: 100%;
  min-height: 100vh;
  
`;

export const Header = styled.div`
    
    width: 100%;
    min-height: 20vh;
`;
export const TextBar = styled.div`
    
    width: 50%;
    min-height: 10vh;
    @media (max-width: 600px) {
        width: 100%;
    }
`;
export const GoodleBar = styled.div`
    
    width: 50%;
    min-height: 10vh;
    @media (max-width: 600px) {
        display: none;
    }

`;
export const GoodleBarSmall = styled.div`
    
    width: 100%;
    min-height: 60vh;
    @media (min-width: 600px) {
        display: none;
        
    }

`;
export const BarContainer = styled.div`
    
    display: flex;
    width: 100%;
`;
export const Footer = styled.div`
    
    width: 100%;
    min-height: 30vh;

`;
export const FooterPeanut = styled.div`
    
    width: 100%;
    min-height: 20vh;

`;

//Exchange

export const MidSection = styled.div`
    
    width: 100%;
    min-height: 70vh;
`;

export const ExchangePanel = styled.div`
    background-color: black;
    width: 70%;
    min-height: 70vh;
    margin-left: 15%;
    @media (max-width: 1200px) {
        width: 100%;
        margin-left: 0%;
    }
    
`;

export const InnerPanel = styled.div`
    
    width: 50%;
    min-height: 70vh;
    float: left;
    color: white;
    
    @media (max-width: 1200px) {
        width: 100%;
        
    }
    
`;
export const InnerGoodlePanel = styled.div`
    
    width: 50%;
    
    min-height: 70vh;
    float: left;
`;
export const InnerPanelButtonWrapper = styled.div`
    
    width: 100%;
    min-height: 10vh;

    padding-top: 3vh;
    display: flex;
    justify-content: center;
`;
export const InnerPanelPrice = styled.div`
    color: #1fff1e;
    width: 100%;
    min-height: 10vh;    
    text-align: center;
`;
export const InnerPanelTextWrapper = styled.div`
    
    width: 100%;
    min-height: 10vh;
    text-align: center;
`;
export const InnerPanelMathWrapper = styled.div`
    
    width: 100%;
    min-height: 10vh;
    display: flex;
    justify-content: center;
`;
export const ExchangePanelHeader = styled.div`
    
    width: 100%;
    height: 5vh;
    text-align: center;
    padding-top: 5vh;
    padding-bottom: 0vh;
    @media screen and (orientation:landscape) {
        padding-top: 0vh;
        padding-bottom: 5vh;
     }
`;
export const ExchangePanelBody = styled.div`
    
    width: 100%;
    height: 30vh;
    @media screen and (orientation:landscape) {
        height: 40vh
     }
`;
export const ExchangePanelFooter = styled.div`
    
    width: 100%;
    height: 30vh;
    @media screen and (orientation:landscape) {
        height: 20vh
     }
`;
export const ApproveButton = styled.button`

    height: 7vh;
`;
export const StyledRoundButton = styled.button`
  padding: 10px;
  border-radius: 100%;
  border: none;
  padding: 10px;
  font-weight: bold;
  font-size: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -webkit-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  -moz-box-shadow: 0px 4px 0px -2px rgba(250, 250, 250, 0.3);
  :active {
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
  }
`;


